module.exports = __webpack_public_path__ + "img/layout-alt-01.1601fe32.svg";